/**
 * Used to ensure redirection URLs for the ProviderRedirect are within our allowed domains
 */
export const WHITELISTED_REDIRECT_URLS = [
  /(^|\.)fih\.io$/,
  /(^|\.)findhotel\.net$/,
  /(^|\.)vio\.com$/
]
